// extracted by mini-css-extract-plugin
export var actionButton = "_yi-2";
export var card = "_yi-0";
export var errorCard = "_yi-3";
export var row = "_yi-1";